import { render } from "./HermesLogo.vue?vue&type=template&id=192b8896&scoped=true"
const script = {}

import "./HermesLogo.vue?vue&type=style&index=0&id=192b8896&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-192b8896"

export default script